import axios from 'axios';
const requests = axios.create({
    //axios.defaults.baseURL = process.env.BASE_URL; //配置个地址以后只需传入地址后缀
    //baseURL: '',
    baseURL: process.env.BASE_URL,
    timeout: 20000,
})

function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        requests.post(url, data)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
    })
};

function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        requests.get(url, {
                params: params
            })
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export default {
    post,
    get
}


// WEBPACK FOOTER //
// ./src/api/request.js